import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBI8YTMCG9lDP8xqr6kJFl29Tv6gL4rUh0",
  authDomain: "pmf-dashboard.firebaseapp.com",
  projectId: "pmf-dashboard",
  storageBucket: "pmf-dashboard.firebasestorage.app",
  messagingSenderId: "332328875977",
  appId: "1:332328875977:web:db15275e89231db4915a18",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export { app };
